import {concatPath, isNotEmpty} from "./CommonUtil";

export function url(path: string){
    if(isNotEmpty(path)){
        if(path.indexOf("http://") === 0 || path.indexOf("https://") === 0){
            return path;
        }else{
            return concatPath(getBaseUrl(), path);
        }
    }
    return path;
}

export function movePage(path:string){
    window.location.href = url(path);
}

// @ts-ignore
export function getUrlParamErrorCode(searchParams):string{
    if(searchParams != null && searchParams.size !== 0){
        const initErrorCode = searchParams.get("ec");
        if(isNotEmpty(initErrorCode)){
            return initErrorCode;
        }
    }
    return "";
}

export function getBaseUrl(){
    // @ts-ignore
    return _BASE_URL;
}


/**
 * 外部サイトへ遷移（履歴なし）
 */
export function replaceTo(url: string | undefined) {
    if(url !== undefined) {
        window.location.replace(url);
    }
}

/**
 * 外部サイトへリダイレクトする
 */
export function redirectTo(url: string) {
    window.location.href = url;
}


export function getPathVariable(location_pathname:string):string{
    if(isNotEmpty(location_pathname)){
        const pathParts = location_pathname.split('/');
        if (pathParts.length != 0){
            return pathParts[pathParts.length - 1];
        }
    }
    return "";
}